import React from "react";
import { MoreVertIcon } from "../../utils/icons";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { browserHistory } from "react-router";
import { setAutoLineupGenBarOpenFlag } from "../../redux/GameInformation/GameInformationAction";
import { connect } from "react-redux";
import { getID, serverTimestamp } from "../../firebase";
import "../Header/GameInformation/GameInformation.css";
import {
  game_logo_path_map,
  platform_logo_path_map,
} from "../../utils/constantInformation";
import DoubleArrowTwoTone from "@material-ui/icons/DoubleArrowTwoTone";
import { getUserJwtToken } from "../../utils/utils";
import axios from "axios";
import { get_export_lineups_url } from "../../utils/lineupApiUtils";
import { setSavedLineupCount } from "../../redux/Lineup/LineupAction";
import { addDataToLineupCollection } from "../../firestoreQueries";
function LineupHeader(props) {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {}, [
    props.game_information_info.lineupReducer.saved_lineup_count,
  ]);

  const handleClickOpen = () => {
    if (
      props.generated_lineup_count ===
        props.game_information_info.lineupReducer.saved_lineup_count ||
      props.myLineups === true
    ) {
      discardAndHandleClose();
    } else {
      setOpen(true);
    }
  };
  const handleLineupExport = async () => {
    // const data = props.lineupData;

    let lineupData = {};
    if (props.myLineups === true) {
      console.log("Export MyLineups");
      console.log(props.lineupData);
      lineupData = props.lineupData;
    } else {
      console.log("Export Generated Lineups");
      let data = props.lineupData;
      lineupData["data"] = data;
      lineupData["optimizer"] = props.optimizer;
    }
    const token = await getUserJwtToken();

    axios
      .post(get_export_lineups_url(props.myLineups), lineupData, {
        headers: {
          "Authorization": token,
          // ClientID: process.env.REACT_APP_COGNITO_CLIENT_ID,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        responseType: "blob",
      })
      .then((response) => {
        console.log(response.headers);
        let slate_id = props.slate_id;
        let fileName = slate_id.substring(0, slate_id.length - 2) + ".csv";
        // let fileName =
        //   response.headers["content-disposition"].split("filename=")[1];
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // IE variant
          window.navigator.msSaveOrOpenBlob(
            new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            }),
            fileName
          );
        } else {
          const url = window.URL.createObjectURL(
            new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        }
      });
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleSaveLineup = async () => {
    // typeof lineupData !== "string"
    // Handle Save All Generated Lineups

    const userID = getID();

    if (typeof props.lineupData !== "string") {
      props.lineupData.map(async (singleLineup) => {
        const toSend = {
          lineup: singleLineup,
          userID: userID,
          lineupIdentifier: singleLineup.lineup_identifier,
          slateID: props.slate_id,
          createdAt: serverTimestamp(),
        };
        addDataToLineupCollection(toSend);
      });
    }
    // Update API
    // Update SavedLineupCounts Redux
    props.update_saved_lineup_count(props.generated_lineup_count);
  };
  function displayDateFromSlateTimeFrame(slateDate) {
    const date = new Date(slateDate);
    // const idxToDayMap = {
    //   0: "Mon",
    //   1: "Mon",
    //   2: "Mon",
    //   3: "Mon",
    //   4: "Mon",
    //   0: "Mon",
    // }
    return date.getDate() + "/" + parseInt(date.getMonth() + 1);
  }
  const discardAndHandleClose = () => {
    props.update_auto_lineup_generation_flag(false);
    props.update_saved_lineup_count(0);
    setOpen(false);
    browserHistory.push("/app");
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="text-white bg-dark">
          {"Discard Lineups"}
        </DialogTitle>
        <DialogContent className="text-white bg-dark">
          <DialogContentText
            id="alert-dialog-description"
            className="text-white"
          >
            Do you want to discard unsaved lineups?
            {/* unused */}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="text-white bg-dark">
          <Button
            onClick={handleClose}
            color="primary"
            className="text-primary font-weight-bold"
          >
            Cancel
          </Button>
          <Button
            className="text-primary font-weight-bold"
            onClick={discardAndHandleClose}
            color="primary"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      {/* <Tour></Tour> */}
      <nav className="navbar border-bottom text-white border-secondary navbar-expand-md fixed-top-sm flex-nowrap justify-content-between bg-dark navbar-dark ">
        {/* <ul className="nav justify-content-between border-bottom border-secondary p-2"> */}
        {/* <li
          className="nav-item align-items-center align-self-center"
          
        > */}
        <button
          onClick={handleClickOpen}
          className="font-weight-bold btn text-primary"
        >
          Close
        </button>
        {/* </li> */}
        {/* <li className="nav-item justify-content-center align-items-center align-self-center text-primary"> */}
        <button
          className="btn btn-sm nav-item active align-items-center align-self-center central-button disabled"
          style={{ cursor: "not-allowed" }}
        >
          <span>
            <img
              src={`${platform_logo_path_map[props.platform]}`}
              className="platform__logo"
            />
          </span>
          <span className="text-white">{" | "}</span>{" "}
          <span>
            <img
              src={`${game_logo_path_map[props.sports]}`}
              className="platform__logo" // game__logo
            />
          </span>
          <span className="text-white">
            {" "}
            | {displayDateFromSlateTimeFrame(props.selected_timeframe)}
          </span>
          <p className="m-0 p-0 text-primary lead">
            <b className="text-bold">DailyFantasy </b>
            <span>
              <DoubleArrowTwoTone className="rotate-90-clock" />
            </span>
          </p>
        </button>
        {/* </li> */}
        {/* <li> */}
        <MoreVertIcon
          className=" disabled nav-item align-items-center align-self-center text-primary"
          data-toggle="modal"
          data-target="#staticBackdropLineUp"
          style={{ cursor: "pointer" }}
        />
        {/* </li> */}
      </nav>
      {/* </ul> */}

      <div
        className="modal fade"
        id="staticBackdropLineUp"
        data-backdrop="staticLineUp"
        tabindex="-1"
        role="dialog"
        aria-labelledby="staticBackdropLabelLineUp"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header d-flex bg-dark text-center text-white lead">
              Lineup Options
              <button
                type="button"
                className="close text-white"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="bg-black">
              <ul className="list-group m-2">
                <li
                  className="d-flex list-group-item bg-dark text-primary justify-content-center"
                  aria-label="Large"
                  aria-describedby="inputGroup-sizing-sm"
                  data-dismiss="modal"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleLineupExport()}
                >
                  <b>Export Lineups</b>
                </li>
                {props.myLineups === true ? null : (
                  // <input type="hidden" />
                  <li
                    className="d-flex list-group-item bg-dark text-primary justify-content-center"
                    aria-label="Large"
                    aria-describedby="inputGroup-sizing-sm"
                    data-dismiss="modal"
                    onClick={handleSaveLineup}
                    style={{ cursor: "pointer" }}
                  >
                    <b>Save Lineups</b>
                  </li>
                )}
              </ul>
            </div>

            <div className="modal-footer bg-black">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    game_information_info: state,
    lineup_state: state.lineupReducer,
    league: state.gameInformationReducer.sports,
    slate_id: state.gameInformationReducer.slate_id,
    selected_timeframe: state.gameInformationReducer.selected_timeframe,
    sports: state.gameInformationReducer.sports,
    platform: state.gameInformationReducer.platform,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    update_auto_lineup_generation_flag: (value) =>
      dispatch(setAutoLineupGenBarOpenFlag(value)),
    update_saved_lineup_count: (value) => dispatch(setSavedLineupCount(value)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(LineupHeader);
